import { FC } from 'react';
import styled from 'styled-components';
import { TAGS } from '../../consts/tags';

interface TagsProps {
  selectTag: (tag: string) => void;
  selectedTag: string;
}

const Tag = styled.div<{ $selected?: boolean }>`
  background-color: ${({ $selected }) =>
    $selected ? '#01352F' : 'transparent'};
  border: 1px solid ${({ theme }) => theme.onHover || '#ffffff'};
  border-radius: 5px;
  display: inline-block;
  margin: 0 10px 10px 10px;
  padding: 5px 8px;
  font-weight: 600;
  cursor: pointer;
`;

const Tags: FC<TagsProps> = ({ selectTag, selectedTag }) => {
  const handleTagSelect = (tag: string) => {
    if (tag === selectedTag) {
      selectTag('');
    } else {
      selectTag(tag);
    }
  };

  return (
    <div>
      {TAGS.map((tag) => {
        return (
          <Tag
            key={tag}
            onClick={() => handleTagSelect(tag)}
            $selected={selectedTag === tag}
          >
            {tag}
          </Tag>
        );
      })}
    </div>
  );
};

export default Tags;
